import { render, staticRenderFns } from "./SIntroduction.vue?vue&type=template&id=393c92c8"
import script from "./SIntroduction.vue?vue&type=script&lang=js"
export * from "./SIntroduction.vue?vue&type=script&lang=js"
import style0 from "./SIntroduction.vue?vue&type=style&index=0&id=393c92c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports